// Test IDs for the SmartEdge B2B lead-gen landing page.

export const NAV = {
  root: 'nav-root',
  logo: 'nav-logo',
  linkPrograms: 'nav-link-programs',
  linkHowItWorks: 'nav-link-how',
  linkResults: 'nav-link-results',
  linkContact: 'nav-link-contact',
  cta: 'nav-cta',
  mobileToggle: 'nav-mobile-toggle',
};

export const HERO = {
  root: 'hero-section',
  headline: 'hero-headline',
  ctaPrimary: 'hero-cta-qualify',
  ctaSecondary: 'hero-cta-programs',
  metrics: 'hero-metrics',
};

export const PROBLEM = {
  root: 'problem-section',
  cardOverpay: 'problem-card-overpay',
  cardCosts: 'problem-card-costs',
  cardMissed: 'problem-card-missed',
};

export const SOLUTION = {
  root: 'solution-section',
  cta: 'solution-cta',
};

export const PROGRAMS = {
  root: 'programs-section',
  card: (slug) => `program-card-${slug}`,
  link: (slug) => `program-link-${slug}`,
};

export const HOW = {
  root: 'how-section',
  cta: 'how-cta',
};

export const TESTIMONIALS = {
  root: 'testimonials-section',
  cardOne: 'testimonial-collins',
  cardTwo: 'testimonial-capital',
};

export const TRUST = {
  root: 'trust-section',
};

export const VIDEO = {
  root: 'video-section',
  play: 'video-play-button',
  dialog: 'video-dialog',
  dialogClose: 'video-dialog-close',
  cta: 'video-cta',
};

export const FINAL_CTA = {
  root: 'final-cta-section',
  cta: 'final-cta-button',
  email: 'final-cta-email',
};

export const CONTACT = {
  root: 'contact-section',
  form: 'contact-form',
  inputName: 'contact-input-name',
  inputEmail: 'contact-input-email',
  inputPhone: 'contact-input-phone',
  selectInterest: 'contact-select-interest',
  inputMessage: 'contact-input-message',
  submit: 'contact-submit',
  success: 'contact-success',
  error: 'contact-error',
};

export const FOOTER = {
  root: 'footer-root',
  emailLink: 'footer-email-link',
  phoneLink: 'footer-phone-link',
};

export const PROGRAM_DETAIL = {
  root: 'program-detail-root',
  title: 'program-detail-title',
  cta: 'program-detail-cta',
  back: 'program-detail-back',
};

export const JOIN = {
  hero: 'join-hero',
  heroCtaApply: 'join-hero-cta-apply',
  heroCtaLearn: 'join-hero-cta-learn',
  opportunity: 'join-opportunity',
  benefits: 'join-benefits',
  benefitCard: (slug) => `join-benefit-${slug}`,
  programs: 'join-programs',
  programCard: (slug) => `join-program-${slug}`,
  process: 'join-process',
  who: 'join-who',
  whoCard: (slug) => `join-who-${slug}`,
  testimonial: 'join-testimonial',
  form: 'join-form',
  inputName: 'join-input-name',
  inputEmail: 'join-input-email',
  inputPhone: 'join-input-phone',
  inputRole: 'join-input-role',
  inputMessage: 'join-input-message',
  partnerType: 'join-partner-type',
  partnerTypeReferral: 'join-partner-type-referral',
  partnerTypeAgent: 'join-partner-type-agent',
  submit: 'join-submit',
  success: 'join-success',
  error: 'join-error',
};

export const EXIT_INTENT = {
  root: 'exit-intent',
  backdrop: 'exit-intent-backdrop',
  cta: 'exit-intent-cta',
  dismiss: 'exit-intent-dismiss',
  close: 'exit-intent-close',
};

// legacy re-export (kept for compatibility)
export const HOME = {
  emergentLink: 'home-emergent-link',
};
